import { API } from "../../../utils";

export const getTenantThemeSettingsApi = async () => {
  const res = await API.get("/settings/theme");
  return res.data;
};

export const updateTenantThemeSettingsApi = async (payload) => {
  const res = await API.put("/settings/theme", payload);
  return res.data;
};
